import {
  SharedStateProvider,
  TransitionsOfCareContent as TransitionsOfCareContentShared,
  useSharedContext,
} from "@metriport/shared-internal";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { getOSSBaseURL } from "../../../api/apiOSS";
import { capture } from "../../../shared/capture";
import { useAppContext } from "../../contexts/app";
import { useIsUserInSandbox } from "../../shared/useIsUserInSandbox";

function TransitionsOfCareContent() {
  const { state } = useAppContext();
  const { sharedState } = useSharedContext();
  const { isUserInSandbox } = useIsUserInSandbox(state);
  const navigate = useNavigate();

  const handleNavigateToPatient = useMemo(() => {
    return (patientId: string) => {
      const basePath = isUserInSandbox ? `/sandbox/patient` : `/patient`;
      const versionPath = sharedState.hasDashV2Access ? `/v2/${patientId}` : `/${patientId}`;
      navigate(`${basePath}${versionPath}`);
    };
  }, [isUserInSandbox, sharedState.hasDashV2Access, navigate]);

  return (
    <TransitionsOfCareContentShared
      onNavigateToPatient={handleNavigateToPatient}
      isImpersonating={state.isImpersonating}
      capture={capture}
    />
  );
}

export default function TransitionsOfCare() {
  const { state } = useAppContext();
  const { isUserInSandbox } = useIsUserInSandbox(state);
  const baseUrl = getOSSBaseURL(isUserInSandbox);
  const isMetriportUser = !!state.user?.email?.endsWith("@metriport.com");

  if (!state.isLoaded) return null;

  return (
    <SharedStateProvider
      authToken={state.authToken}
      baseUrl={baseUrl}
      ehrDetails={undefined}
      isMetriportUser={isMetriportUser}
      isUserInSandbox={isUserInSandbox}
      userEmail={state.user?.email}
      featureFlags={state.featureFlags}
    >
      <TransitionsOfCareContent />
    </SharedStateProvider>
  );
}
